import React from 'react'
import { ChevronDown, Plus, Trash2 } from 'lucide-react'
import { ActionsDiv } from '../../../AddProductForm/style'
import { useOrderItems } from '../../contexts/OrderItemsContext'
import {
  ActionOutlineButton, KitContainer, KitHeader, KitSummaryLabel, KitSummaryRow,
  RoundCollapseButton, RoundTrashButton, Summary, SummaryItem, SummaryLabel, SummaryValue,
} from '../../style'
import { formatCurrency } from '../../utils'
import ProductCard from './ProductCard'

interface KitGroupProps {
  kitIdx: number
}

const KitGroup: React.FC<KitGroupProps> = ({ kitIdx }) => {
  const {
    addedProducts, openKits, setOpenKits, handleRemoveKit,
    setProductToEdit, setEditingProductIndex, setOpenProductIndex, setShowAddProductForSection,
    setIsKitMode,
  } = useOrderItems()

  const kits = addedProducts
    .map((p, i) => ({ product: p, index: i }))
    .filter(({ product }) => product.kitIndex === kitIdx)

  const kitTotalItems = kits.length
  const kitTotalPieces = kits.reduce((sum, { product }) => {
    const pieces = product.sizeQuantities
      ? Object.values(product.sizeQuantities).reduce((s, q) => s + q, 0)
      : product.totalItems || 0
    return sum + pieces
  }, 0)
  const kitTotal = kits.reduce((sum, { product }) => sum + (product.subtotal || 0), 0)
  const isKitOpen = openKits[kitIdx] !== false;

  return (
    <KitContainer>
      <KitHeader>
        <KitSummaryRow>
          <Summary>
            <SummaryItem>
              <KitSummaryLabel>Conjunto {kitIdx + 1}</KitSummaryLabel>
            </SummaryItem>
            <SummaryItem>
              <SummaryLabel>Quantidade de itens:</SummaryLabel>
              <SummaryValue>{kitTotalItems}</SummaryValue>
            </SummaryItem>
            <SummaryItem>
              <SummaryLabel>Quantidade de peças:</SummaryLabel>
              <SummaryValue>{kitTotalPieces}</SummaryValue>
            </SummaryItem>
            <SummaryItem>
              <SummaryLabel>Total:</SummaryLabel>
              <SummaryValue>{formatCurrency(kitTotal)}</SummaryValue>
            </SummaryItem>
          </Summary>
          <ActionsDiv style={{ gap: '8px' }}>
            <RoundTrashButton
              type="button"
              onClick={() => handleRemoveKit(kitIdx)}
            >
              <Trash2 size={16} />
            </RoundTrashButton>
            <RoundCollapseButton
              type="button"
              isOpen={isKitOpen}
              onClick={() => setOpenKits((prev) => ({ ...prev, [kitIdx]: !isKitOpen }))}
            >
              <ChevronDown size={16} />
            </RoundCollapseButton>
          </ActionsDiv>
        </KitSummaryRow>
      </KitHeader>

      {isKitOpen && (
        <>
          {kits.map(({ product, index }) => (
            <ProductCard key={`${product.fashionProductId}-${index}`} product={product} index={index} isInsideKit />
          ))}

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
            <ActionOutlineButton type="button" onClick={() => {
              setProductToEdit(null);
              setEditingProductIndex(null);
              setOpenProductIndex(null);
              setShowAddProductForSection(kitIdx);
              setIsKitMode(true);
            }}>
              <Plus size={16} /> Adicionar Item ao Conjunto
            </ActionOutlineButton>
          </div>
        </>
      )}
    </KitContainer>
  )
}

export default KitGroup
